var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.automatorModeTooltip,
    hideOnTargetClick: false
  }),expression:"{\n    content: automatorModeTooltip,\n    hideOnTargetClick: false\n  }"}],class:Object.assign({}, {'c-slider-toggle-button': true,
    'c-slider-toggle-button--right': _vm.isTextAutomator},
    _vm.tutorialClass),attrs:{"aria-label":_vm.automatorModeTooltip},on:{"click":_vm.toggleAutomatorMode}},[_c('i',{staticClass:"fas fa-cubes"}),_c('i',{staticClass:"fas fa-code"})])}
var staticRenderFns = []

export { render, staticRenderFns }